import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  name: string;
  detail: string;
  quote: string;
  image: string;
};
const testimonials: Testimonial[] = [{
  name: 'Mariana G.',
  detail: 'Mamá de Emilia, 8 meses',
  quote: 'La tercera noche durmió 7 horas seguidas. Yo lloré de alivio. Nunca pensé que algo tan barato me devolvería tanto.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/ba47e74d-5b02-4a4a-8f11-252e1b5fb209.jpg'
}, {
  name: 'Carlos R.',
  detail: 'Papá de Mateo, 14 meses',
  quote: 'Lo mejor es que no hay que dejarlo llorar. Seguimos los horarios tal cual y en tres días cambió todo en casa.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bd3b24a0-3c7f-408f-a271-5a5c96a5226e.jpg'
}, {
  name: 'Daniela P.',
  detail: 'Mamá de Sofía, 5 meses',
  quote: 'Había leído mil blogs y ninguno me daba un orden. Aquí sabía exactamente qué hacer a cada hora. Eso fue la diferencia.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7a1a516a-583b-4efe-a805-8f6edf00a902.jpg'
}];
export function Testimonials() {
  return <section className="w-full bg-cream-dark py-16 sm:py-20" aria-labelledby="testimonials-title" data-id="element-90" data-mp="780ivmr7388w">
      <div className="mx-auto max-w-6xl px-5" data-id="element-91" data-mp="c622q9wg3blf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-92" data-mp="c8y0ny8am09v">
          <h2 id="testimonials-title" className="font-display text-3xl font-black text-slateblue-900 sm:text-4xl" data-id="element-93" data-mp="zw68onx3vnfl">
            1,200 familias ya durmieron esta semana
          </h2>
          <p className="mt-3 text-[15px] text-slateblue-600" data-id="element-94" data-mp="q5v2eupy925j">
            Estos son algunos de los mensajes que recibimos después de las
            primeras 72 horas.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-95" data-mp="1iuiga58dcp92">
          {testimonials.map(t => <figure key={t.name} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slateblue-100" data-id="element-96" data-mp="1nmses9njuxmy">
              <div className="flex" aria-label="5 de 5 estrellas" data-id="element-97" data-mp="1siec16d4ypsh">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-98" data-mp="1og9jkayfbz7f" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-slateblue-900" data-id="element-99" data-mp="1ekppzv7c1clu">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-slateblue-100 pt-4" data-id="element-100" data-mp="14t22g5dwcfpn">
                <img src={t.image} alt="" className="h-11 w-11 rounded-full object-cover" data-id="element-101" data-mp="10s9tld8xsctw" />
                <div data-id="element-102" data-mp="vuq2vdv1y7l2">
                  <p className="text-sm font-bold text-slateblue-900" data-id="element-103" data-mp="qtke1r4ij4gt">
                    {t.name}
                  </p>
                  <p className="text-xs text-slateblue-600" data-id="element-104" data-mp="32hp5t1ufkbnp">{t.detail}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}